import HandsonTable from './HandsonTable.vue';

export default HandsonTable;
